import { Store } from "@tanstack/store";
import { tokenInterceptor } from '@/services/shared/http';
import { getAccount, loginUser } from '@/services';
import { LoginPayload, AccountResponse } from '@/types';

export interface AuthState {
  isAuthenticated: boolean;
  isError: boolean;
  state: "idle" | "loading" | "finished";
  user?: AccountResponse['data'];
  token?: string;
}

const initialState: AuthState = {
  isAuthenticated: !!tokenInterceptor.getToken(),
  isError: false,
  state: "idle",
  user: undefined,
  token: tokenInterceptor.getToken(),
};

export const authStore = new Store(initialState);

export const login = async (credentials: LoginPayload, onSuccessRedirect: () => void) => {
  authStore.setState((state) => ({
    ...state,
    state: "loading",
  }));

  try {
    const response = await loginUser(credentials);

    tokenInterceptor.setToken(response.data.token);

    const accountResponse = await getAccount();
    console.log('accountResponse', accountResponse)

    authStore.setState((state) => ({
      ...state,
      isAuthenticated: true,
      state: "finished",
      user: accountResponse,
      token: response.data.token,
    }));

    onSuccessRedirect();

  } catch (error) {

    authStore.setState((state) => ({
      ...state,
      isAuthenticated: false,
      isError: true,
      state: "finished",
      user: undefined,
      token: undefined,
    }));

    throw error; 
  }
};

export const initializeAuthStore = async () => {
  const token = tokenInterceptor.getToken();
  
  if (token) {
    try {
      const accountResponse = await getAccount();
      
      authStore.setState((state) => ({
        ...state,
        user: accountResponse,
      }));
    } catch (error) {
      // Token might be invalid, clear the auth state
      await logout();
    }
  }
};

export const logout = async () => {
  authStore.setState((state) => ({
    ...state,
    state: "loading",
  }));

  return new Promise<void>((resolve) => {
    setTimeout(() => {
      tokenInterceptor.clearToken();

      authStore.setState((state) => ({
        ...state,
        isAuthenticated: false,
        state: "finished",
        user: undefined,
        token: undefined,
      }));
      resolve();
    }, 500);
  });
};

export const isAuthenticated = () => {
  return authStore.state.isAuthenticated;
};

export const getUserData = () => {
  return authStore.state.user;
};

export const useAuthState = () => authStore.state;